import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteBotApiKey } from '../../features/bots/services'
import type { BotApiKey } from '../../features/bots/types'

import { useQueryKeys } from '../useQueryKeys'

export function useDeleteBotApikey({ workspaceId, botId }: { workspaceId: string; botId: string }) {
  const queryClient = useQueryClient()
  const { listBotApiKeys } = useQueryKeys()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => deleteBotApiKey({ workspaceId, id }),
    onSuccess: async (_, { id }) => {
      queryClient.setQueryData<BotApiKey[]>(listBotApiKeys(botId), (baks) => baks?.filter((iak) => iak.id !== id))
    },
  })
}
